import { IconHome } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

import { useCogniteClient } from '#core/hooks/useCogniteClient.ts';

import { AtlasChat } from '#components/AtlasChat.tsx';

export const Route = createFileRoute('/dashboard/')({
  component: RouteComponent,
  staticData: {
    route: {
      icon: IconHome,
      sidebarPosition: 1,
      title: 'Dashboard',
    },
  },
});

function RouteComponent() {
  const client = useCogniteClient();
  return <AtlasChat client={client} />;
}
